import { InputTemplate } from '../../../types/Forms'

export const isBasicInput = ({ key }: InputTemplate) => false // key === undefined || key === null
// todo need to figure out how to recognize default/basic category

export default isBasicInput
